


































































































import { Component, Vue, Prop, Emit, Watch } from "vue-property-decorator";
import { MessageDto } from "@/store/messages/message.interface";
import dayjs from "dayjs";
import Message from "@/store/messages";

@Component
export default class AppMessageItem extends Vue {
  @Prop() item: MessageDto;
  @Prop() index: number;
  updatedItem: MessageDto;

  get formatTotal() {
    let val = (this.item.total / 1).toFixed(0).replace(",", ".");
    return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  }

  get percentage() {
    return parseInt(
      ((this.item.total_sented * 100) / this.item.total).toFixed(0)
    );
  }

  @Watch("item")
  onItemChanged(val: MessageDto, oldVal: MessageDto) {
    this.item = val;
  }

  get startDate() {
    return dayjs(this.item.send_date).format("DD/MM/YYYY");
  }

  get startTime() {
    return dayjs(dayjs().format("YYYY-MM-DD ") + this.item.start_time).format(
      "HH:mm"
    );
  }

  async onResume() {
    await Message.updateOne(
      this.item.id as number,
      {
        status_id: 3
      } as any
    );
  }

  async onPause() {
    await Message.updateOne(
      this.item.id as number,
      {
        status_id: 6
      } as any
    );
  }

  @Emit("itemUpdated")
  async itemUpdated() {
    return {
      item: this.updatedItem,
      index: this.index
    };
  }

  mounted() {
    this.sockets.subscribe("messageUpdated_" + this.item.id, (data: any) => {
      this.updatedItem = data;
      this.itemUpdated();
    });
  }

  destroyed() {
    this.sockets.unsubscribe("messageUpdated_" + this.item.id);
  }
}
